import { cn } from "admin-ui/utils/cn"
import { IconProps } from "."

export default function CheckMini({
  className,
  transform,
  ...reset
}: Readonly<IconProps>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("h-6 w-6", className)}
      transform={transform}
      {...reset}
    >
      <path
        d="M4.05713 11.4849L8.62856 17.1992L18.3428 5.19922"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
